const transfers = {
  transfer: "โอนย้าย", // translated
  transfers: "การโอน", // translated
  dateAndTime: "วันและเวลา", // translated
  transferFrom: "โอนจาก", // translated
  duration: "ระยะเวลา", // translated
  numOfPersons: "จำนวนคน", // translated
  baggageAllowance: "น้ำหนักสัมภาระ", // translated
  small: "เล็ก", // translated
  big: "ใหญ่", // translated
  provider: "ผู้ให้บริการ", // translated
  vehicle: "ยานพาหนะ", // translated
  distance: "ระยะทาง", // translated
  price: "ราคา", // translated
  inboundJourney: "การเดินทางขาเข้า", // translated
  outboundJourney: "การเดินทางขาออก", // translated
  arrivalTime: "เวลาถึง", // translated
  flightDetails: "รายละเอียดของเที่ยวบิน", // translated
  inboundPickupDate: "วัน-เวลารับส่ง", // translated
  outboundPickupDate: "วันที่รับสินค้าขาออก", // translated
  travelInfo: "ข้อมูลการเดินทาง", // translated
  flightsInfo: "ข้อมูลเที่ยวบิน", // translated
  airportYouAreFlyingFrom: "สนามบินที่คุณเดินทางมา", // translated
  airportYouAreFlyingTo: "สนามบินที่คุณกำลังบินไป", // translated
  inboundFlightNumber: "หมายเลขเที่ยวบินขาเข้า", // translated
  outboundFlightNumber: "หมายเลขเที่ยวบินขาออก", // translated
  inboundAirlineName: "ชื่อสายการบินขาเข้า", // translated
  outboundAirlineName: "ชื่อสายการบินขาออก", // translated
  tripMode: "โหมดการเดินทาง", // translated
  airportToPoint: "สนามบินถึงจุด", // translated
  pointToAirport: "ชี้ไปที่สนามบิน", // translated
  roundTrip: "ไป - กลับ", // translated
  destinationPoint: "จุดปลายทาง", // translated
  originPoint: "จุดกำเนิด", // translated
  transferType: "ประเภทการโอน", // translated
  min: "นาที", // translated
  max: "สูงสุด", // translated
  pieces: "ชิ้นส่วน", // translated
  cancelationIs: "การยกเลิกคือ", // translated
};


export default transfers;
